import { createApp, defineAsyncComponent, ref, onMounted, inject } from 'vue';

/////////////////////////////////////////////////////////////////////////////////////////////////// PLUGINS
import FontsLoader from './plugins/fonts-loader/index.js';
import { createI18n } from 'vue-i18n';
import Recaptcha from './plugins/recaptcha/index.js';
import CookiesBar from './plugins/cookies-bar/index.js';
import Modals from './plugins/modals/index.js';
import Collapse from './plugins/collapse/index.js';
import SiteDrawer from './plugins/site-drawer/index.js';
// import ScrollTo from './plugins/scroll-to/index.js';
// import Animations from './plugins/animations/index.js';

/////////////////////////////////////////////////////////////////////////////////////////////////// COMPONENTS
const ProductsList = defineAsyncComponent(() => import('./products-list.vue'));
const ProjectsList = defineAsyncComponent(() => import('./projects-list.vue'));
const PhotoSlider = defineAsyncComponent(() => import('./photo-slider.vue'));
const FormRequest = defineAsyncComponent(() => import('./form-request.vue'));
const FormEquipment = defineAsyncComponent(() => import('./form-equipment.vue'));
const FormConstruction = defineAsyncComponent(() => import('./form-construction.vue'));
const ArticleInnerPhotos = defineAsyncComponent(() => import('./article-inner-photos.vue'));
const FormContact = defineAsyncComponent(() => import('./form-contact.vue'));
const GoogleMap = defineAsyncComponent(() => import('./components/google-map/index.vue'));

/////////////////////////////////////////////////////////////////////////////////////////////////// APP
const i18n = createI18n({
    legacy: false,
    locale: window.Laravel.locale,
    messages: window.Laravel.translations,
});

import { Fancybox } from '@fancyapps/ui';
import galleryOptions from "./imports/fancyOptions.js";
Fancybox.bind("[data-fancybox]", galleryOptions);
import { viewportSize, UrlParams } from './imports/utils'; // devices
const UrlParamsInstance = new UrlParams();

createApp({
    components: {
        ProductsList,
        ProjectsList,
        PhotoSlider,
        FormRequest,
        FormEquipment,
        FormConstruction,
        ArticleInnerPhotos,
        FormContact,
        GoogleMap,
    },
    setup() {
        if (process.env.NODE_ENV === 'production') console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;');

        ///////////////////////////////////////////////////////////////////////////// scrollTop
        const scrollTop = ref(0);
        const onScroll = () => {
            scrollTop.value = window.scrollY;
        }
        window.addEventListener("scroll", onScroll, { passive: true });

        ///////////////////////////////////////////////////////////////////////////// viewportSize
        const viewport = ref(viewportSize());
        const onResize = () => {
            viewport.value = viewportSize();
        }
        window.addEventListener("resize", onResize, { passive: true });

        // onMounted(() => {
        //     if (devices()) {
        //         document.getElementsByTagName('html')[0].classList.add('touch-device');
        //     }
        // });

        ///////////////////////////////////////////////////////////////////////////// Gemi
        const $modal = inject('$modal');
        const modalParam = UrlParamsInstance.get('modal'); // Example usage of UrlParamsInstance

        onMounted(() => {
            if (modalParam === 'gemi') {
                $modal.show(`modal-${modalParam}`);
            }
        });

        return {
            assets: `/site/${process.env.MIX_TEMPLATE_FOLDER}/dist`,
            scrollTop,
            viewport,
        }
    },
})
    .component('BgImage', defineAsyncComponent(() => import('./components/bg-image/index.vue')))
    .component('BgVideo', defineAsyncComponent(() => import('./components/bg-video/index.vue')))
    .use(FontsLoader, {
        id: "zvp8zyr",
    })
    .use(i18n)
    .use(Recaptcha, {
        key: window.Laravel.recaptcha,
        hide: true
    })
    .use(CookiesBar)
    .use(Modals)
    .use(Collapse)
    .use(SiteDrawer)
    // .use(ScrollTo, {
    //     // debug: true,
    //     headerHeight: 155,
    //     menuSelector: '.page-menu'
    // })
    // .use(Animations)
    .mount('#app')